var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoirLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83337 11.0002C1.83337 16.0629 5.93729 20.1668 11 20.1668C16.0628 20.1668 20.1667 16.0629 20.1667 11.0002C20.1667 5.93741 16.0628 1.8335 11 1.8335C5.93729 1.8335 1.83337 5.93741 1.83337 11.0002Z",
    stroke: "#BAC1DA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9167 1.87939C11.9167 1.87939 14.6667 5.50023 14.6667 11.0002C14.6667 16.5002 11.9167 20.1211 11.9167 20.1211M10.0834 20.1211C10.0834 20.1211 7.33339 16.5002 7.33339 11.0002C7.33339 5.50023 10.0834 1.87939 10.0834 1.87939M2.41089 14.2086H19.5892M2.41089 7.79189H19.5892",
    stroke: "#BAC1DA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoirLanguage);
export default __webpack_public_path__ + "static/media/iconoir_language.1d9fa8093387f1bc6d8faea1848f308f.svg";
export { ForwardRef as ReactComponent };